
// React Library
import React, { useState, useRef, useEffect } from 'react'

// Helmet
import Helmet from 'react-helmet'

// React Router DOM
import { withRouter, useHistory } from 'react-router-dom'

// Content
import { show as content } from './CommoditesContent'

// Query Related
import QueryHelper from '../Queries/QueryHelper'
import { GET_COMMODITIES } from '../Queries/Queries'

// Mutation Related
import { DELETE_COMMODITY } from '../Mutations/Mutations'

// Utils
import AddIconButton from '../Utils/AddIconButton'
import { formatArrayForAgGrid } from '../Utils/utils'
import RootGrid from '../Utils/RootGrid'
import RootAgGrid from '../Utils/RootAgGrid'
import SearchTextInput from '../Utils/SearchTextInput'

// Trie-Search Algorithm
import TrieSearch from 'trie-search'

// Query Component
const ShowCommodities = props => {
  return (
    <>
      <Helmet>
        <title>Commodity</title>
      </Helmet>
      <QueryHelper query={GET_COMMODITIES}>
        {({ data }) => {
          const { getCommodities: { commodities } } = data

          // Some Formatting...
          const commoditiesArray = commodities.map(commodity => {
            const cargo = commodity.cargo ? 'cargo' : 'nonCargo'
            return {
              ...commodity,
              cargo,
              forwardArray: commodity.forwardArray.map((elem, pos, arr) => formatArrayForAgGrid(elem, pos, arr))

            }
          })

          // Render
          return (
            <ShowCommodityTable
              commodities={commoditiesArray}
            />
          )
        }}
      </QueryHelper>
    </>
  )
}

const ShowCommodityTable = (props) => {
  const { commodities = [] } = props

  // History For Links
  const history = useHistory()

  // Hooks For Search Bar Functionality
  const [search, setSearch] = useState('')
  const [searchCommodity, setSearchCommodity] = useState(commodities)

  // Trie-Search To Look For The Following Fields...
  const ts = new TrieSearch(['commodityName'], {
    idFieldOrFunction: 'id'
  })
  // The Array To Be Filtered (All Commodities In the DB)
  ts.addAll(commodities)

  // Trie-Search Logic
  const searchRef = useRef(search)
  useEffect(() => {
    if (searchRef.current !== search) {
      searchRef.current = search
      if (!search) {
        setSearchCommodity(commodities)
      } else {
        const foundCommodities = ts.get(search, TrieSearch.UNION_REDUCER)
        setSearchCommodity(foundCommodities)
      }
    }
  }, [search, commodities, ts])

  // Column Structure
  const columnDefs = [
    { field: 'commodityName', headerName: 'Commodity', cellRenderer: 'link', width: 200 },
    { field: 'cargo', headerName: 'Cargo', width: 50 },
    { field: 'stowFactor', headerName: 'Stow Factor', width: 50 },
    { field: 'forwardArray', headerName: 'Forward Array' }
  ]

  // Link Of The Update Commodity Page
  const updateLink = 'update-commodity'

  // We Render Search Bar + Create Button + Grid
  return (
    <RootGrid>

      {/* Search Bar + Create Button */}
      <SearchTextInput
        autoFocus
        label='Search'
        style={{ maxWidth: 600, margin: '0 auto' }}
        onChange={e => {
          setSearch(e.target.value)
        }}
        value={search}
      >
        <AddIconButton
          onClick={() => history.push(content.createButton.link)}
          color='primary'
        >
          {content.createButton.name}
        </AddIconButton>
      </SearchTextInput>

      {/* Commodities Grid (Made By Us) */}
      <RootAgGrid
        columnDefs={columnDefs}
        filteredArray={searchCommodity}
        mutation={DELETE_COMMODITY}
        objectNameKey1='commodityName'
        type='Commodity'
        updateLink={updateLink}
      />

    </RootGrid>
  )
}

export default withRouter(ShowCommodities)
